import React from 'react';
import classNames from 'classnames';
import { useVideoConfig } from '../../../video-config-provider';
import s from './tile-container.scss';
export const TileContainer = ({ children, focused = false, screenShare = false, singleTile = false, sharing = false, }) => {
    const { mobile, webinar, sidePanelOpened, desktopUsedViewportHeight } = useVideoConfig();
    const landscape = window.innerWidth > window.innerHeight;
    const tileMaxWidth = `calc((100vh - ${desktopUsedViewportHeight}px) / 0.5625)`;
    return (React.createElement("div", { className: classNames(s.outerContainer, {
            [s.mobile]: mobile,
            [s.desktop]: !mobile,
            [s.webinar]: webinar,
            [s.focused]: focused || screenShare || singleTile,
            [s.screenShare]: screenShare,
            [s.singleTile]: singleTile,
            [s.sidePanelOpened]: mobile && sidePanelOpened,
            [s.landscape]: landscape,
            [s.sharing]: sharing,
        }), style: { maxWidth: tileMaxWidth } },
        React.createElement("div", { className: s.innerContainer },
            React.createElement("div", { className: s.tile }, children))));
};
//# sourceMappingURL=tile-container.js.map